import styled from '@emotion/styled';
import { Stack } from '@ui-components/neo.tax';

export const PageContainer = styled(Stack)({
  width: '100%',
  padding: '1.5rem',
  overflowY: 'auto',
  maxWidth: 1430,
});

export const PageContentContainer = styled(Stack)({
  flex: 1,
  padding: '1.5rem 0',
});

export const PageContent = styled(Stack)({
  height: '100%',
  padding: 24,
  overflowY: 'auto',
  width: '100%',
});
